// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fqbE","clinicsSelect":"styles_clinicsSelect__QBYNl"};